/* eslint-disable  @typescript-eslint/no-explicit-any */ // AJB: remove
import { Box, Typography } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import HomePageSearchRequest from "@/models/HomePageSearchRequest";
import { HomePageSearchResponse } from "@/models/HomePageSearchResponse";
import PillButton from "@/app/shared/PillButton";
import { NAV_SELECTED_BACKGROUND_COLOR } from "@/app/layout/LayoutConstants";

export default function PaginationSection({
  searchRequest,
  searchResponse,
  handleSearchRequestChange,
}: {
  searchRequest: HomePageSearchRequest;
  searchResponse: HomePageSearchResponse;
  handleSearchRequestChange: (updates: any) => void;
}) {
  const canGoBack = searchRequest.page > 1;
  const canGoNext = searchRequest.page < searchResponse.results.totalPages;
  return (
    <Box
      sx={(theme) => ({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        paddingTop: 2,
        paddingBottom: 2,
        gap: 2,
        [theme.breakpoints.down("sm")]: {
          gap: 0,
        },
      })}
    >
      <PillButton
        onClick={() =>
          handleSearchRequestChange({ page: searchRequest.page - 1 })
        }
        disabled={searchRequest.page === 1}
        startIcon={<NavigateBeforeIcon />}
        sx={{
          backgroundColor: canGoBack
            ? NAV_SELECTED_BACKGROUND_COLOR
            : "transparent",
        }}
      >
        Back
      </PillButton>
      <Typography variant="body1" sx={{ paddingLeft: 2, paddingRight: 2 }}>
        Page {searchRequest.page}{" "}
        <small>of {searchResponse.results.totalPages}</small>
      </Typography>
      <PillButton
        onClick={() =>
          handleSearchRequestChange({ page: searchRequest.page + 1 })
        }
        disabled={searchRequest.page === searchResponse.results.totalPages}
        endIcon={<NavigateNextIcon />}
        sx={{
          backgroundColor: canGoNext
            ? NAV_SELECTED_BACKGROUND_COLOR
            : "transparent",
        }}
      >
        Next
      </PillButton>
    </Box>
  );
}
